const translations = {
    title: 'Company Details'
};

export default translations;
